module.exports = __webpack_public_path__ + "img/googlelogo.686f8efa.svg";